import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.jpg';
import '../styles/App.css';

const MAX_ATTEMPTS = 8;
const POLL_INTERVAL_MS = 2500;

const SubscriptionSuccess = () => {
  const { user, refreshPlan, plan } = useAuth();
  const [activated, setActivated] = useState(false);
  const attemptsRef = useRef(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!user?.sub || activated) return;

    const poll = async () => {
      await refreshPlan(user.sub);
      attemptsRef.current += 1;
    };

    // Poll immediately, then on interval until plan is paid or max attempts reached
    poll();
    timerRef.current = setInterval(() => {
      if (attemptsRef.current >= MAX_ATTEMPTS) {
        clearInterval(timerRef.current);
        return;
      }
      poll();
    }, POLL_INTERVAL_MS);

    return () => clearInterval(timerRef.current);
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if ((plan === 'monthly' || plan === 'annual') && !activated) {
      setActivated(true);
      clearInterval(timerRef.current);
    }
  }, [plan, activated]);

  return (
    <div className="page-content" style={{ textAlign: 'center', paddingTop: '80px' }}>
      <div style={{ marginBottom: '16px' }}>
        <img src={logo} alt="Micropincher" style={{ height: '64px', objectFit: 'contain' }} />
      </div>
      <h1 style={{ fontSize: '22px', color: '#3fb950', marginBottom: '8px' }}>
        {activated ? 'Subscription activated!' : 'Activating your subscription…'}
      </h1>
      <p style={{ color: '#8b949e', fontSize: '13px', marginBottom: '32px' }}>
        {activated
          ? 'Your plan is now active. You have full access to all features.'
          : 'Please wait while we confirm your payment. This usually takes a few seconds.'}
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
        <Link to="/opportunities" className="subscription-btn" style={styles.btn}>Go to Opportunities</Link>
        <Link to="/trades" className="subscription-btn" style={styles.btn}>Go to Trades</Link>
      </div>
    </div>
  );
};

const styles = {
  btn: {
    padding: '4px 16px',
    background: '#21262d',
    color: '#ffffff',
    border: '1px solid #ffffff',
    borderRadius: '2px',
    textDecoration: 'none',
    fontSize: '11px',
    fontFamily: "'Courier New', Courier, monospace",
    fontWeight: 'normal',
    cursor: 'pointer',
    transition: 'all 0.2s',
    minWidth: '120px',
    display: 'inline-block',
    textAlign: 'center',
  },
};

export default SubscriptionSuccess;
